import Vue from 'vue'
import store from '../store'
import con from '../const.js'

const state = store.state


function is_expired(login_time,expire_time){
	let cur_time = Math.floor((new Date()).getTime() / 1000)
	let expired_time = login_time + expire_time
	//console.log('expired_time:'+expired_time+',cur_time:'+cur_time)
	return expired_time < cur_time
}



function isLogin(){
	let user = state.user
	if(state.user.login_server_time == 0){
		user = JSON.parse(Vue.localStorage.get(con.LSKEY))
		if(!user || typeof user !== 'object'){	
			user = state.user
		}else{
			if(user.login_time > 0 && !is_expired(user.login_time,user.expire_time)){
				store.commit('setLoginInfo',user.info)
				store.dispatch('updateGlobalVar','all')
				.then(data=>{
					store.commit('setGlobalVars',data)
				})
			}
		}
		
	}
	return user.login_time > 0 && !is_expired(user.login_time,user.expire_time)
}

function getLocalLogin(){
	let user = JSON.parse(Vue.localStorage.get(con.LSKEY))
	if(typeof user === 'object'){
		if(!is_expired(user.login_time,user.expire_time)){
			store.commit('setLoginInfo',user.info)
		}else{
			store.commit('clearLoginInfo')
		}
	}else{
		store.commit('clearLoginInfo')
		return null
	}
	return store.state.user
}

function setLocalLogin(user){
	store.commit('setLoginInfo',user)
}

function setGlobalAreas(data){
	store.commit('setGlobalAreas',data)
}

function getGlobalAreas(){
	let areas = JSON.parse(Vue.localStorage.get('areas'))	
	if(typeof areas === 'object'){
		store.commit('setGlobalAreas',areas)
	}else{
		return null
	}
	return store.state.global_areas
}

const Auth = {
	isLogin,
	getLocalLogin,
	setLocalLogin,
	setGlobalAreas,
	getGlobalAreas
}

export default Auth


// WEBPACK FOOTER //
// ./src/libs/auth.js